// @flow
import typeToReducer from 'type-to-reducer'
import { reject, sortWith, descend, prop, propEq } from 'ramda'

import type { Favorites as RadioChannelFavorites } from '@alphaott/api-client/types/favorites'

import {
  FETCH_FAVORITE_RADIO_CHANNELS_IDS_TYPE,
  ADD_RADIO_CHANNEL_ID_TO_FAVORITE_IDS_TYPE,
  REMOVE_RADIO_CHANNEL_ID_FROM_FAVORITE_IDS_TYPE,
} from '../../actions'

export type RadioChannelFavoritesState = {|
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: RadioChannelFavorites,
|}

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
}

const radioChannelFavorites = typeToReducer(
  {
    [FETCH_FAVORITE_RADIO_CHANNELS_IDS_TYPE]: {
      LOADING: (state): RadioChannelFavoritesState => ({
        ...state,
        isLoading: true,
        isSuccess: false,
      }),

      SUCCESS: (state, action): RadioChannelFavoritesState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        data: sortWith([descend(prop('ts'))], action.payload.data),
      }),

      ERROR: (state, action): RadioChannelFavoritesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
    [ADD_RADIO_CHANNEL_ID_TO_FAVORITE_IDS_TYPE]: {
      LOADING: (state): RadioChannelFavoritesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): RadioChannelFavoritesState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        data: [action.payload.data, ...state.data],
      }),

      ERROR: (state, action): RadioChannelFavoritesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
    [REMOVE_RADIO_CHANNEL_ID_FROM_FAVORITE_IDS_TYPE]: {
      LOADING: (state): RadioChannelFavoritesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): RadioChannelFavoritesState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        data: reject(propEq('_id', action.meta.itemId), state.data),
      }),

      ERROR: (state, action): RadioChannelFavoritesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
  },
  initialState,
)

export { radioChannelFavorites }
